import React from "react";
import { Grid } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import Charts from "../Echarts";
import spread from "../../../utils/m4k/semic_data/spread";
import midData from "../../../utils/m4k/semic_data/marketSize";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridRoot: {
      textAlign: "center",
      color: "white",
      boxSizing: "border-box",
    },
    img: {
      height: "45vh",
    },
  })
);
const SemicLeft: React.FC = () => {
  const classes = useStyles();

  return (
    <Grid container direction="row" className={classes.gridRoot}>
      <Grid item xs={12} className={classes.img}>
        <div style={{ height: "5vh", fontSize: "60px", color: "#6effff" }}>
          半导体工艺流程
        </div>
        <img
          src={require("../../../images/all.png")}
          alt=""
          style={{
            width: "100%",
            height: "40vh",
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <div style={{ height: "5vh", fontSize: "60px", color: "#6effff" }}>
          国内半导体硅片厂商分布
        </div>
        <Charts option={spread} style={{ height: "40vh" }} />
      </Grid>
    </Grid>
  );
};

export default SemicLeft;
